// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"2db8c417","118":"300beaf0","176":"a6b6ccc1","216":"031c894c","345":"f452bd8d","347":"d3401881","393":"13d7bd5d","437":"93e62405","453":"4022256b","487":"dd28b0e4","549":"0241c4e7","582":"f9484b96","971":"7f0e18f7"}[chunkId] + ".chunk.js";
};